export default "<vle-checkbox [isChecked]=\"value\" [isDisabled]=\"isDisabled\" (checkedChange)=\"onCheckedChange($event)\"></vle-checkbox>\n";